export const LOAD_STATE = 'LOAD_STATE';
export const SET_LOADING = 'SET_LOADING';
export const SET_NEW_JOB_SITE = 'SET_NEW_JOB_SITE';
export const SET_CURRENT_JOB_SITE = 'SET_CURRENT_JOB_SITE';
export const CREATE_JOB_SITE = 'CREATE_JOB_SITE';
export const UPDATE_JOB_SITE = 'UPDATE_JOB_SITE';
export const API_ERRORS = 'API_ERRORS';
export const ARCHIVE_JOB_SITE = 'ARCHIVE_JOB_SITE';
export const SORT_JOB_SITES = 'SORT_JOB_SITES';
export const SELECT_LIST_JOB_SITE = 'SELECT_LIST_JOB_SITE';
export const SET_MAP_CENTER_POSITION = 'SET_MAP_CENTER_POSITION';
export const BULK_UPDATE_LOCATION_TRACKING_SETTING = 'BULK_UPDATE_LOCATION_TRACKING_SETTING';
export const UPDATE_PROJECT_USERS = 'UPDATE_PROJECT_USERS';
export const SCROLL_TO_JOB_SITE = 'SCROLL_TO_JOB_SITE';
export const SET_FILE_PARAMS = 'SET_FILE_PARAMS';
export const REMOVE_FILE = 'REMOVE_FILE';
export const SET_UPLOAD_LOADING = 'SET_UPLOAD_LOADING';
